import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['../app.component.scss', './not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  public title: string;
  public content: string;

  constructor() { }

  ngOnInit() {
    this.title = localStorage.getItem('err-title') || 'pagina não encontrada!';
    this.content = localStorage.getItem('err-content') || 'verifique a url e tente novamente.';
  }

}
